import { useTranslation } from "react-i18next";
import spmlogo from "../../resources/img/spmlogo.png";
import Spinner from "../spinner/Spinner";

const Title = ({ errorMessage, loading }) => {
  const { t } = useTranslation();
  const spinner = loading && <Spinner />;

  return (
    <div className="w3-display-container content-container">
      <div className="w3-display-middle w3-center" style={{ width: "90%", maxWidth: "700px" }}>
        {errorMessage}
        <div className="w3-card-4 welcome-card w3-padding-large">
          <h1 className="w3-margin-bottom">{t("title_welcome")}</h1>
          <img src={spmlogo} alt="SPM logo" className="spm-logo w3-margin-top w3-margin-bottom" />
        </div>
        <div className="w3-panel w3-card-4 w3-center disclaimer-background">
          <h2 className="disclaimer-text">
            ⚠️ {t("title_disclaimer")} {t("title_disclaimer_2")}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Title;
